import { RootState } from '../../app/storeTypes';
import { DropDownOptions } from '../../types';

const getGenericBladeNode = (state: RootState, id: string) => {
    if (!state.genericBlade) {
        throw new Error('genericBlade slice not added to store');
    }
    const genericBladeNode = state.genericBlade[id];

    if (!genericBladeNode) {
        throw new Error(`generic slice node ${id} not found`);
    }

    return genericBladeNode;
};

export const selectGenericBladeFetchUrl = (state: RootState, id: string) => {
    const genericBlade = getGenericBladeNode(state, id);

    return genericBlade.urlFetchEndPoint;
};

export const selectGenericBladeSubmitUrl = (state: RootState, id: string) => {
    const genericBlade = getGenericBladeNode(state, id);

    return genericBlade.urlSubmitEndPoint;
};

export const selectGenericBladeCancelUrl = (state: RootState, id: string) => {
    const genericBlade = getGenericBladeNode(state, id);

    return genericBlade.urlCancelEndPoint;
};

export const selectGenericBladeContent = (state: RootState, id: string) => {
    const genericBlade = getGenericBladeNode(state, id);

    return genericBlade.content;
};

export const selectGenericBladeAPI = (state: RootState, id: string) => {
    const genericBlade = getGenericBladeNode(state, id);

    return genericBlade.api;
};

export const selectGenericBladeType = (state: RootState, id: string) => {
    const genericBlade = getGenericBladeNode(state, id);

    return genericBlade.genericBladeType;
};

export const selectGenericBladeFetchApiStatus = (
    state: RootState,
    id: string,
) => {
    const genericBlade = getGenericBladeNode(state, id);

    return genericBlade.apiFetchStatus;
};

export const selectGenericBladeSubmitApiStatus = (
    state: RootState,
    id: string,
) => {
    const genericBlade = getGenericBladeNode(state, id);

    return genericBlade.apiSubmitStatus;
};

export const selectGenericBladeFetchApiErrorMessage = (
    state: RootState,
    id: string,
) => {
    const genericBlade = getGenericBladeNode(state, id);

    return genericBlade.apiFetchErrorMessage;
};

export const selectGenericBladeSubmitApiErrorMessage = (
    state: RootState,
    id: string,
) => {
    const genericBlade = getGenericBladeNode(state, id);

    return genericBlade.apiSubmitErrorMessage;
};

export const selectGenericBladeCancelApiErrorMessage = (
    state: RootState,
    id: string,
) => {
    const genericBlade = getGenericBladeNode(state, id);

    return genericBlade.apiCancelErrorMessage;
};

export const selectGenericBladeSubmittedPayload = (
    state: RootState,
    id: string,
) => {
    const genericBlade = getGenericBladeNode(state, id);

    return genericBlade.submittedPayload;
};

export const selectGenericBladeHardValidations = (
    state: RootState,
    id: string,
) => {
    const genericBlade = getGenericBladeNode(state, id);

    return genericBlade.content.validations?.hardValidations;
};

export const selectGenericBladeSoftValidations = (
    state: RootState,
    id: string,
) => {
    const genericBlade = getGenericBladeNode(state, id);

    return genericBlade.content.validations?.softValidations;
};

export const selectGenericBladeParameters = (
    state: RootState,
    id: string,
) => {
    const genericBlade = getGenericBladeNode(state, id);

    return genericBlade.contentParams;
};

export const selectTimeDurationYears = (
    state: RootState,
    id: string,
) => {
    const genericBlade = getGenericBladeNode(state, id);

    const years = genericBlade.content?.years as Record<string, DropDownOptions<string>[]>;

    return years?.dropdownOptions?.map(({ key, label, value }) => ({ label: key || label || '', value }));
};

export const selectTimeDurationMonths = (
    state: RootState,
    id: string,
) => {
    const genericBlade = getGenericBladeNode(state, id);

    const months = genericBlade.content?.months as Record<string, DropDownOptions<string>[]>;

    return months?.dropdownOptions?.map(({ key, label, value }) => ({ label: key || label || '', value }));
};

export const selectGenericBladeTimeDurationApiData = (
    state: RootState,
    id: string,
) => {
    const genericBlade = getGenericBladeNode(state, id);

    return {
        years: genericBlade.api?.years ?? '',
        months: genericBlade.api?.months ?? '',
    };
};
